

import React, { useRef, useState, useEffect } from 'react';
import { useScreenClass } from '../../utils';
import { getConfiguration } from '../../config';
import { Div } from '../../primitives';

export const NO_PROVIDER_FLAG = 'NO_PROVIDER_FLAG';

// $FlowFixMe
export const ScreenClassContext = React.createContext(NO_PROVIDER_FLAG);

const ScreenClassProvider = ({
  children,
  useOwnWidth = true,
  fallbackScreenClass = null




}) => {
  const screenClassRef = useRef();
  const [mounted, setMounted] = useState(false);
  const detectedScreenClass = useScreenClass(screenClassRef, fallbackScreenClass || '');
  const { defaultScreenClass } = getConfiguration();

  const screenClass = mounted ? detectedScreenClass : fallbackScreenClass || defaultScreenClass;

  useEffect(() => setMounted(true), []);

  return (
    <ScreenClassContext.Provider value={screenClass}>
      {useOwnWidth ?
      <Div ref={useOwnWidth ? screenClassRef : null}>{children}</Div> :
      <>{children}</>}
    </ScreenClassContext.Provider>);

};

export default ScreenClassProvider;